import { useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import QuoteEmailTemplate from './QuoteEmailTemplate';
import { styleReset } from './quotePdfTemplate/styleReset';

export default function QuoteEmailTemplateString() {
  useEffect(() => {
    const templateHtmlString = `<html><style>${styleReset}</style> ${renderToStaticMarkup(
      <QuoteEmailTemplate />,
    )}</html>`;

    // eslint-disable-next-line no-console
    console.log('templateHtmlString: ', templateHtmlString);
  }, []);

  return <div>View console</div>;
}
